import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import { AwCarousel } from "aw-carousel";
import ApiCard from "../components/ApiCardComponent/ApiCard.component";
import logoPipe from '../utils/resources/ApiLogos/pipedriveIcon.png'
import logoHubSpot from '../utils/resources/ApiLogos/hubspotIcon.png'
import logoSalesForce from '../utils/resources/ApiLogos/Salesforce.com_logo.png'
import logoDynamics from '../utils/resources/ApiLogos/dynmaicsIcon.png'
import sapLogo from '../utils/resources/ApiLogos/SAP_2011_logo.svg.png'
import oracleLogo from '../utils/resources/ApiLogos/OracleNetSuiteIcon.png'
import odoLogo from '../utils/resources/ApiLogos/odoo_logo.png'
import sageLogo from '../utils/resources/ApiLogos/sageIcon.png'

export interface IApiCard {
    description: string;
    image: string;
    initialActive: boolean;
    title: string;
    link: string;
    bgColor?: boolean;
}

const ApiModulePage = () => {
    const { t } = useTranslation();
    const context: IOutletContext = useOutletContext();
    const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1000);

    useEffect(() => {
        const handleResize = () => {
            setIsWideScreen(window.innerWidth > 1000);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        context.setState(t('API'));
    }, [context, t]);


    const cartesCRMs: IApiCard[] = [ 
        { description: t("pipesDesc"), image: logoPipe, initialActive: false, title:"Pipedrive", link: 'https://www.pipedrive.com/' },
        { description: t("dynamicsDesc"), image: logoDynamics, initialActive: true, title:"Dynamics", link: 'https://dynamics.microsoft.com/' },
        { description: t("salesForceDesc"), image: logoSalesForce, initialActive: true, title:"SalesForce",link: 'https://www.salesforce.com/' },
        { description: t("HubDesc"), image: logoHubSpot, initialActive: false, title:"Hubspot", link: 'https://www.hubspot.com/' }
    ];
    
    const cartesERPs: IApiCard[] = [
        { description: t("sapBusinessOneDesc"), image: sapLogo, initialActive: true, title:"Sap", link: 'https://www.sap.com/products/erp/business-one.html' },
        { description: t("odooDesc"), image: odoLogo, initialActive: true, title:"Odoo", link: 'https://www.odoo.com' },
        { description: t("oracleNetsuiteDesc"), image: oracleLogo, initialActive: true, title:"Oracle Netsuite", link: 'https://www.netsuite.com/' },
        { description: t("sageX3Desc"), image: sageLogo, initialActive: false, title:"Sage X3", link: 'https://www.sage.com/en-gb/products/sage-x3/' }
    ];

    return (
        <>
            <div className="row ms-2 me-2 text-center" style={{ maxWidth: '100%' }} id="contenidorCRM">
                <div className='col-12 px-1 mt-2 '>
                    <div className='rounded-1 p-2 mb-2' style={{ color: 'var(--text-primary)', backgroundColor: 'var(--background-secondary)', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)' }}>
                        <div className="col my-2">
                            <div className="row">
                                <span className="h4 text-start">CRM's</span>
                            </div>
                            <div className="row mt-2">
                                <AwCarousel items={cartesCRMs} rows={isWideScreen ? 1 : 4} cols={isWideScreen ? 4 : 1}>
                                    {(item: IApiCard) =>
                                        <ApiCard description={item.description} image={item.image} initialActive={item.initialActive} logoBgColor={item.bgColor} title={item.title} link={item.link}/>
                                    }</AwCarousel>
                            </div>
                        </div>
                    </div>
                    <div className='rounded-1 p-2 mb-2' style={{ color: 'var(--text-primary)', backgroundColor: 'var(--background-secondary)', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)' }}>
                        <div className="col my-2">
                            <div className="row">
                                <span className="h4 text-start">ERP's</span>
                            </div>
                            <div className="row mt-2">
                                <AwCarousel items={cartesERPs} rows={isWideScreen ? 1 : 4} cols={isWideScreen ? 4 : 1}>
                                    {(item: IApiCard) =>
                                        <ApiCard description={item.description} image={item.image} initialActive={item.initialActive} logoBgColor={item.bgColor} title={item.title} link={item.link}/>
                                    }</AwCarousel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ApiModulePage;
